<template>
	<v-layout row wrap align-center class="align-center justify-space-between">
		<v-layout row align-center>
			<v-btn icon color="primary" @mousedown.prevent @click="onTogglePlayback" :disabled="!canPlay" class="mr-4">
				<v-icon>{{ isPlaying ? 'pause' : 'play_arrow' }}</v-icon>
			</v-btn>

			<v-btn icon small @mousedown.prevent @click="onZoomIn" class="mr-1">
				<v-icon>zoom_in</v-icon>
			</v-btn>
			<v-btn icon small @mousedown.prevent @click="onZoomOut" class="mr-2">
				<v-icon>zoom_out</v-icon>
			</v-btn>
			<v-btn text small @mousedown.prevent @click="onFitView" class="mr-4">Fit</v-btn>
		</v-layout>

		<div>
			<div class="caption grey--text text--lighten-1 text-uppercase font-weight-bold">Current position</div>
			<div class="display-1 font-weight-black primary--text mono-font">
				{{ currentTimeFormatted }}
			</div>
		</div>
	</v-layout>
</template>

<script>
export default {
	name: 'AudioToolbar',
	props: {
		isPlaying: { type: Boolean, default: false },
		canPlay: { type: Boolean, default: false },
		currentTimeFormatted: { type: String, default: '' },
		zoomAt: { type: Function, default: null },
		fitView: { type: Function, default: null },
		togglePlayback: { type: Function, default: null }
	},
	methods: {
		onFitView() {
			this.fitView();
		},
		onZoomIn() {
			this.zoomAt(1.25, 0.5);
		},
		onZoomOut() {
			this.zoomAt(1 / 1.25, 0.5);
		},
		onTogglePlayback() {
			this.togglePlayback();
		}
	}
};
</script>

<style scoped>
.mono-font {
	font-family: 'Roboto Mono', monospace !important;
	letter-spacing: -1px;
}
</style>
